import * as React from 'react';
import { ITranslationObject } from '../types';

export interface ITranslation {
  translations: ITranslationObject;
}

export const defaultTranslation: ITranslation = {
  translations: {},
};

export const TranslationsContext: React.Context<ITranslation> = React.createContext(
  defaultTranslation
);

TranslationsContext.displayName = 'TranslationsContext';
